module.exports = __webpack_public_path__ + "static/img/46.1ec6339.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/page/Music/GoodsShow/AirPods Pro/imgs/second/46.jpg
// module id = qf6i
// module chunks = 0